export default "__VITE_ASSET__Cj605_mI__"